import isApiError from "@insite/client-framework/Common/isApiError";
import { get } from "@insite/client-framework/Services/ApiService";

export interface ApiResultModel {
    uri: string;
    id: string;
    erpOrderNumber: string;
    webOrderNumber: string;
    orderDate: Date;
    status: string;
    statusDisplay: string;
    customerNumber: string;
    customerSequence: string;
    customerPO: string;
    currencyCode: string;
    currencySymbol: string;
    terms: string;
    shipCode: string;
    salesperson: string;
    btCompanyName: string;
    btAddress1: string;
    btAddress2: string;
    btAddress3: string;
    btAddress4: string;
    billToCity: string;
    billToState: string;
    billToPostalCode: string;
    btCountry: string;
    stCompanyName: string;
    stAddress1: string;
    stAddress2: string;
    stAddress3: string;
    stAddress4: string;
    shipToCity: string;
    shipToState: string;
    shipToPostalCode: string;
    stCountry: string;
    notes: string;
    productTotal: number;
    orderSubTotal: number;
    discountAmount: number;
    orderDiscountAmount: number;
    productDiscountAmount: number;
    shippingAndHandling: number;
    shippingCharges: number;
    handlingCharges: number;
    otherCharges: number;
    taxAmount: number;
    orderTotal: number;
    modifyDate: Date;
    requestedDeliveryDateDisplay: null;
    orderLines: any[];
    orderPromotions: any[];
    shipmentPackages: any[];
    returnReasons: string[];
    orderHistoryTaxes: any[];
    productTotalDisplay: string;
    orderSubTotalDisplay: string;
    orderTotalDisplay: string;
    orderGrandTotalDisplay: string;
    discountAmountDisplay: string;
    orderDiscountAmountDisplay: string;
    productDiscountAmountDisplay: string;
    taxAmountDisplay: string;
    totalTaxDisplay: string;
    shippingAndHandlingDisplay: string;
    shippingChargesDisplay: string;
    handlingChargesDisplay: string;
    otherChargesDisplay: string;
    canAddToCart: boolean;
    canAddAllToCart: boolean;
    showTaxAndShipping: boolean;
    shipViaDescription?: string;
    fulfillmentMethod: string;
    customerVatNumber: string;
    vmiLocationId: string;
    vmiLocationName: string;
    properties: Properties;
}

export interface Properties {
    [key: string]: any;
}

const getAllJobSitesUrl = "api/v1/osn/getOrder";

export async function getOrderStatusService(orderId: string) {
    try {
        const result = await get<ApiResultModel>(`${getAllJobSitesUrl}?orderId=${orderId}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorMessage || error.errorJson.message || "Something went wrong!",
                statusCode: error.status,
            };
        }
        if (error.errorMessage) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: error.status,
            };
        }
        throw error;
    }
}
